import {
  getReportMailingBaseFormShape,
  refineSendDayRequiredWhenActive,
} from '@common';
import type { TFunction } from 'i18next';
import { z } from 'zod';

const buildEditReportMailingFormSchema = (t: TFunction<'common'>) =>
  refineSendDayRequiredWhenActive(
    z.object({
      ...getReportMailingBaseFormShape(t),
      recipientGroupId: z.string().nullable(),
    }),
    t
  );

export type EditReportMailingFormSchemaType = ReturnType<
  typeof buildEditReportMailingFormSchema
>;

export const getEditReportMailingFormSchema = (
  t: TFunction<'common'>
): EditReportMailingFormSchemaType => buildEditReportMailingFormSchema(t);
